module.exports = __webpack_public_path__ + "img/missing.a8c8422e.png";